import styled from 'styled-components';
import { BP_MOBILE_MAX, BP_TABLET_MAX } from '../../assets/styles/breakpoints';
import { rgba } from 'polished';
import {
  COLOR_DARK_PURPLE,
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_BLUE,
} from '../../assets/styles/colors';

export default styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 0px;
  padding-top: 60px;
  max-width: 1080px;
  margin: 0 auto;

  @media (max-width: ${BP_TABLET_MAX}px) {
    max-width: 560px;
    margin: 0 auto;
    flex-direction: column;
    max-width: 560px;
    padding-top: 30px;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const InfoWrapSC = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  width: 30%;
  padding: 24px;
  svg {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }
  .email-text {
    color: ${rgba(COLOR_DARK_PURPLE, 0.4)};
    word-break: break-all;
    text-align: center;
  }
  button {
    margin-top: 16px;
    max-width: 183px;
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
    padding-top: 0px;
    padding-bottom: 20px;
    align-items: center;
  }
`;

export const SettingsWrapSC = styled.div`
  width: 70%;
  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
  }
`;

export const SettingsCardWrapSC = styled.div`
  padding: 24px;
  width: 100%;
  background: ${COLOR_WHITE};
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  border-bottom: 1px solid ${rgba(COLOR_BLACK, 0.1)};
  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    border-bottom: none;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    padding: 16px;
  }
`;

export const PersonalSettingsWrapSC = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  .item {
    padding: 16px 0;
    display: flex;
    width: 50%;
    &__img-wrap {
      width: 50px;
      min-width: 50px;
      height: 50px;
      background-color: ${rgba(COLOR_BLUE, 0.1)};
      border-radius: 50px;
      margin-right: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__text-wrap {
      display: flex;
      flex-direction: column;
      .data-text {
        word-break: break-all;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    .item {
      width: 100%;
    }
  }
`;
export const ApprovalSettingsWrapSC = styled.div`
  display: flex;
  flex-flow: row wrap;
  .item {
    padding: 16px 0;
    display: flex;
    width: 100%;
    &__check-wrap {
      margin-top: 5px;
      width: 24px;
      min-width: 24px;
      height: 24px;
      background-color: ${rgba(COLOR_DARK_PURPLE, 0.2)};
      border-radius: 8px;
      margin-right: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 22px;
      }
    }
    &__text-wrap {
      display: flex;
      flex-direction: column;
      p {
        max-width: 432px;
        &:first-child {
          max-width: 400px;
        }
      }
    }
  }
`;
